import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { deleteSubscription } from '../../actions';
import { CANCEL_PLAN_IMMEDIATELY } from '../../constants';
import _ from 'lodash';
import { Button } from '@blueprintjs/core';
import styled from 'styled-components';
import StripeButton from '../../containers/Buttons/StripeButton';
import TalkToSalesButton from '../../containers/Buttons/TalkToSalesButton';
import {
  Plan,
  INDIVIDUAL_PLAN,
  ENTERPRISE_PLAN
} from '../../components/Plans';


const Subscriptions = styled.div`
  width: 100%;
`;

const Container = styled.div`
  width: 300px;
`;

const PlansContainer = styled.div`
   width: 100%;
   display: flex;
   flex-direction: row;
   align-items: flex-start;
   justify-content: flex-start;
   flex-wrap: wrap;
`;

class Settings extends React.Component {

  onCancelClick = () => {
    const subscriptions = _.get(this.props.customer, 'subscriptions.data');
    for (const subscription of subscriptions) {
      this.props.deleteSubscription(this.props.accessToken, subscription.id);
    }
  };

  render() {

    const sources = _.get(this.props.customer, 'sources.data', []);
    const defaultSource = _.get(this.props.customer, 'default_source');
    const cards = [];
    for (const source of sources) {
      if (source.object === 'card') {
        const last4 = _.get(source, 'last4', null);
        const expMonth = _.get(source, 'exp_month', null);
        const expYear = _.get(source, 'exp_year', null);
        const cardId = _.get(source, 'id', null);
        const cardType = _.get(source, 'brand', 'Card');
        const cardStatus = defaultSource === cardId
          ? <span className="pt-text-muted">(active)</span>
          : null;
        const card = (
          <div className="pt-form-group" key={cardId}>
            <label className="pt-label pt-large" htmlFor={cardId}>
              <span style={{marginRight: 5}}>{cardType}</span>
              {cardStatus}
            </label>
            <div className="pt-form-content">
              <input id={cardId} className="pt-input pt-disabled pt-fill"
                     placeholder={`**** **** **** ${last4}`}/>
            </div>
            <div className="pt-form-helper-text">
              Expires {expMonth}/{expYear}
            </div>
          </div>
        );
        cards.push(card);
      }
    }

    let creditCards = null;
    if (cards.length > 0) {
      creditCards = <Container>{cards}</Container>;
    }

    const cancelText = CANCEL_PLAN_IMMEDIATELY ? "Cancel subscription" : "Cancel auto-renew";
    const cancelButton = (
      <Container>
        <Button
          className="pt-intent-danger pt-fill"
          onClick={this.onCancelClick}
          icon="credit-card"
          text={cancelText}
          loading={!this.props.isCustomerSynced}
        />
      </Container>
    );

    const nb_subscriptions = _.get(
      this.props.customer,
      'subscriptions.data',
      []
    ).length;

    // TODO
    const activeSubscription = 'Premium';
    const freeTrialEndDate = '6/20/2018';
    const nextPaymentDate = '6/20/2018';
    const subOrFreeTrial = 'free trial';

    return nb_subscriptions > 0 ? (
        <Subscriptions>
          <br/>
          <h5>Subscription</h5>
          <p>Your are subscribed to <strong>{activeSubscription}</strong>.</p>
          <p>Your {subOrFreeTrial} will expire on
            <strong>{freeTrialEndDate}</strong>.</p>
          <p>Your subscription will renew on <strong>{nextPaymentDate}</strong>.
          </p>
          {cancelButton}
          <br/>
          <h5>Payment methods</h5>
          {creditCards}
        </Subscriptions>
      ) : (
        <Subscriptions>
          <br/>
          <h5>Subscription</h5>
          <p>You have no active subscription.</p>
          <br/>
          <h5>Plans</h5>
          <PlansContainer>
            <Plan plan={INDIVIDUAL_PLAN} button={<StripeButton plan={INDIVIDUAL_PLAN}/>}/>
            <Plan plan={ENTERPRISE_PLAN} button={<TalkToSalesButton/>}/>
          </PlansContainer>
        </Subscriptions>
      );

  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteSubscription
  }, dispatch)
}

function mapStateToProps(state) {
  return {
    accessToken: state.accessToken,
    customer: state.customer,
    isCustomerSynced: state.isCustomerSynced
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);



// WEBPACK FOOTER //
// ./src/containers/BillingSettings/index.js